import { Cover } from "./Cover";
import { Detailed as DetailedComponent } from "./Detailed";
import { OfferTemplate } from "./OfferTemplate";

export const Detailed = Object.assign(DetailedComponent, {
  Cover,
  OfferTemplate,
});
